import React from 'react';
import CaspianRoleService from '../../../../Services/CaspianRoleService';
import CheckboxField from '../CheckboxField';
import LoadingIcon from '../../../LoadingIcon';
import UserRoleItem from '../../../../Domain/UserRoleItem';

export default class CaspianRolesMultiCheck extends React.Component {
  static defaultProps = {
    label: '',
    fieldName: '',
    onChange: () => {},
    selected: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      usersCaspianRoles: [],
      selected: [],
    };

    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate() {
    if (this.state.loading === true) {
      this.setState({ loading: false });
    }
  }

  populateListData() {
    CaspianRoleService.GetRoleList().then((result) => {
      const caspianRoles = [];
      result.forEach((item) => {
        if (this.props.selected.roles) {
          caspianRoles.push(new UserRoleItem(item, this.props.selected.roles));
        } else if (
          this.props.selected.RelatedUsers &&
          this.props.selected.RelatedUsers.length > 0 &&
          this.props.selected.RelatedUsers[0].roles
        ) {
          caspianRoles.push(new UserRoleItem(item, this.props.selected.RelatedUsers[0].roles));
        }
      });
      this.setState({ usersCaspianRoles: caspianRoles });
    });
  }

  multiSelectOnChange(selected) {
    const roles = this.state.usersCaspianRoles;
    const role = roles.find((r) => r.RoleId === selected);
    role.UserHasIt = !role.UserHasIt;
    this.setState({ usersCaspianRoles: roles });

    this.props.onChange(roles);
  }

  renderCheckboxes() {
    return (
      <div className='row'>
        {this.state.usersCaspianRoles.map((role) => (
          <div
            key={role.RoleId}
            className=' col-2'
          >
            {role.Name}
            <CheckboxField
              onChange={() => this.multiSelectOnChange(role.RoleId)}
              value={role.UserHasIt}
              className=' '
            />
          </div>
        ))}
      </div>
    );
  }

  render() {
    return (
      <div className='w-100'>
        <div className='text-center hover rounded arial'>
          {this.props.label && (
            <label
              className='m-0 p-0 defaultfontsize '
              htmlFor={'htmlidfor' + this.props.fieldName}
            >
              {this.props.label}
            </label>
          )}
          {this.state.loading ? (
            <LoadingIcon
              loading={true}
              className='h6'
            />
          ) : (
            this.renderCheckboxes()
          )}
        </div>
      </div>
    );
  }
}
